import { InjectionToken } from '@angular/core';

import type { OrderStatusBlockScenarioContent } from '@front-platform/content-builder';
import { DoodOrderModel } from '@store/order/order.model';

/** Runtime VM emitted by `OrderStatusBlock` data sources. */
export type OrderStatusBlockViewModel = {
  orders: readonly DoodOrderModel[];
  onSiteLocationName: string;
};

/** Scenario transport matches the runtime VM shape (orders cast at the preview boundary). */
export type OrderStatusBlockScenarioViewModel = OrderStatusBlockScenarioContent;

export const ORDER_STATUS_BLOCK_LOADING_VM: OrderStatusBlockViewModel = {
  orders: [],
  onSiteLocationName: '',
};

export interface OrderStatusBlockDataSource {
  readonly vm$: import('rxjs').Observable<OrderStatusBlockViewModel>;
}

export const ORDER_STATUS_BLOCK_DATA_SOURCE = new InjectionToken<OrderStatusBlockDataSource>(
  'ORDER_STATUS_BLOCK_DATA_SOURCE',
);
